export default __webpack_public_path__ + "static/activities_cover-4626da39e9ca333fed6bd82d2c36b05b.jpg";